import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
  Box,
  Card,
  type CardProps,
  Flex,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import classNames from 'classnames';

import styles from './selectable-card.module.css';

interface SelectableCardProps extends CardProps {
  icon: JSX.Element;
  label: string;
  tooltip?: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const SelectableCard = ({
  icon,
  label,
  tooltip,
  isSelected,
  isDisabled,
  onClick,
  className,
  ...cardProps
}: SelectableCardProps) => {
  const dimmed = classNames(isDisabled && styles.dimmed);

  return (
    <Card
      role="button"
      direction="row"
      onClick={isDisabled ? undefined : onClick}
      aria-pressed={isSelected}
      aria-disabled={isDisabled}
      className={classNames(
        styles.card,
        isSelected && styles.selected,
        isDisabled && styles.disabled,
        className
      )}
      {...cardProps}
    >
      <Flex p="10px" w="full" alignItems="center">
        <Flex w="38px" justifyContent="center" className={dimmed}>
          <Box w="27px">{icon}</Box>
        </Flex>

        <Text ml="3" flex="1" className={dimmed}>
          {label}
        </Text>

        {tooltip && (
          <Tooltip
            label={tooltip}
            fontSize="xs"
            openDelay={300}
            variant="label"
          >
            <InfoOutlineIcon
              boxSize={3}
              color="text.primary"
              cursor="pointer"
            />
          </Tooltip>
        )}
      </Flex>
    </Card>
  );
};
